import React, { useState } from 'react'

export const ServerUrlInput = () => {
    const url = localStorage.getItem('treelist-single-user-server-url') || ''
    const [singleUserServerUrl, setSingleUserServerUrl] = useState(url)

    const urlChanged = (event) => {
        const value = event.target.value
        setSingleUserServerUrl(value)
        localStorage.setItem('treelist-single-user-server-url', value)
    }

    return (
        <>
            <label htmlFor="server-url">Server url: </label>
            <input id="server-url" type="text" value={singleUserServerUrl} onChange={urlChanged}></input>
            <br />
            <br />
        </>
    )
}
